import * as React from "react";
import MuiFormHelperText, {
    FormHelperTextProps as MuiFormHelperTextProps,
    FormHelperTextClassKey as MuiFormHelperTextClassKey
} from "@material-ui/core/FormHelperText";

export type FormHelperTextClassKey = MuiFormHelperTextClassKey;

export interface FormHelperTextProps extends MuiFormHelperTextProps { }

class FormHelperText extends React.PureComponent<FormHelperTextProps> {
    render() {
        const { ...props } = this.props;
        return <MuiFormHelperText {...props}>
            {this.props.children}
        </MuiFormHelperText>;
    }
}

export default FormHelperText; 